<select
  class="form-control form-select"
  name="protocolPdfTemplates"
  [appDisable]="readonly"
  [ngModel]="selectedProtocolPdfTemplate"
  (ngModelChange)="onProtocolPdfTemplateSelected($event)">
  @for (protocolPdfTemplate of protocolPdfTemplates; track protocolPdfTemplate) {
    <option value="{{ protocolPdfTemplate }}">
      <span>{{ protocolPdfTemplate | translate }}</span>
    </option>
  }
</select>
